<script lang="ts">
	import { page } from '$app/stores';
	import { translations } from '$lib/i18n/translations';
	import type { Property } from '$lib/satellite.types';

	const property = $page.data.property as Property;
	const version = $page.data.version;
	const t = translations(property.language);

	$: currentCategory = $page.data.article?.category?.slug || $page.data.category?.slug;
	$: currentPage = $page.data.currentPage || '';

	const links = [
		{
			slug: 'about',
			text: t('about'),
			href: '/informations/' + (property.language == 'fr' ? 'a-propos' : 'about')
		},
		{
			slug: 'our-writers',
			text: t('ourWriters'),
			href: '/informations/' + (property.language == 'fr' ? 'nos-redacteurs' : 'our-writers')
		},
		{
			slug: 'terms-of-use',
			text: t('termsOfUse'),
			href:
				'/informations/' + (property.language == 'fr' ? 'conditions-dutilisation' : 'terms-of-use')
		},
		{
			slug: 'privacy-policy',
			text: t('privacyPolicy'),
			href:
				'/informations/' +
				(property.language == 'fr' ? 'politique-de-confidentialite' : 'privacy-policy')
		},
		{
			slug: 'editorial-policies',
			text: t('editorialPolicies'),
			href:
				'/informations/' +
				(property.language == 'fr' ? 'politiques-editoriales' : 'editorial-policies')
		},
		{
			slug: 'contact-us',
			text: t('contactUs'),
			href: '/informations/' + (property.language == 'fr' ? 'contactez-nous' : 'contact-us')
		}
	];
</script>

<footer
	class="pt-10 pb-28 mt-10 border-t border-gray-100 [view-transition-name:footer] [content-visibility: auto] print:hidden"
>
	<div class="max-w-lg lg:max-w-screen-lg px-4 xl:px-0 mx-auto">
		<div class="flex flex-col lg:flex-row gap-6 text-sm">
			<div class="basis-4/12 text-center lg:text-left">
				<a href="/">
					<img
						src="/logo.svg"
						alt={property.name}
						class="{property.aspectRatio} h-10 mx-auto lg:mx-0"
					/></a
				>
				<p class="mt-2">
					{property.description}
				</p>
				<p class="text-xs mt-3 text-gray-400">
					&copy; {new Date().getFullYear()}
					<a target="_blank" href="https://www.attraction.ca/" class="hover:underline"
						>Attraction Web S.E.C.</a
					>
					{t('allRightsReserved')}
				</p>
			</div>
			<div class="basis-8/12">
				<div class="flex flex-col lg:flex-row gap-6">
					<div class="basis-4/12 text-center lg:text-left">
						<strong>{property.name}</strong>
						<ul>
							{#each property.categories as category}
								<li>
									<a
										href={`/${category.slug}`}
										class:underline={currentCategory == category.slug}
										class="text-gray-500 hover:underline hover:text-black">{category.name}</a
									>
								</li>
							{/each}
						</ul>
					</div>
					<div class="basis-4/12 text-center lg:text-left">
						<strong>{t('usefulLinks')}</strong>
						<ul>
							{#each links as link}
								<li>
									<a
										class:underline={link.slug == currentPage}
										class="text-gray-500 hover:underline hover:text-black"
										href={link.href}>{link?.text}</a
									>
								</li>
							{/each}
						</ul>
					</div>
					<div class="basis-4/12 text-center lg:text-left">
						<strong>{t('followUs')}</strong>
						<ul class="mb-4">
							{#each property.links as link}
								<li>
									<a
										target="_blank"
										class="text-gray-500 hover:underline hover:text-black"
										href={link.link}>{link.name}</a
									>
								</li>
							{/each}
						</ul>
						<small class="text-xs text-gray-400">v{version}</small>
					</div>
				</div>
			</div>
		</div>
	</div>
</footer>
